/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import moment from 'moment';
import { UtilityType } from '../../shared/Utils/Constants';

export const getUtilityTitle = (utilityType: string) => {
  let utilityName = '';
  switch (utilityType?.toLocaleLowerCase()) {
    case UtilityType.Electric.toLocaleLowerCase():
      utilityName = UtilityType.Electricity;
      break;
    case UtilityType.Water.toLocaleLowerCase():
      utilityName = UtilityType.Water;
      break;
    default:
      break;
  }
  return utilityName;
};

export const formatDate = (inputDate: string) =>
  moment(inputDate, 'YYYY-MM-DD').format('DD MMM');

export const formatDateFor = (inputDate: string) =>
  moment(inputDate, 'YYYY-MM-DD').format('DD MMM YYYY');

export const formatDateforSave = (inputDate: string) =>
  moment(inputDate).format('YYYY-MM-DD');
